import { StyleSheet } from 'react-native';

// 尺寸配置
const SIZES = {
    small: {
        boxSize: 16,
        iconSize: 10,
        fontSize: 14,
        descriptionSize: 12,
        minHeight: 40,
        borderRadius: 3,
    },
    medium: {
        boxSize: 20,
        iconSize: 14,
        fontSize: 16,
        descriptionSize: 14,
        minHeight: 48,
        borderRadius: 4,
    },
    large: {
        boxSize: 24,
        iconSize: 16,
        fontSize: 18,
        descriptionSize: 16,
        minHeight: 56,
        borderRadius: 5,
    },
};

// 颜色配置
const COLORS = {
    primary: '#007AFF',
    border: '#D1D1D6',
    borderDisabled: '#E5E5EA',
    text: '#1C1C1E',
    textSecondary: '#8E8E93',
    textDisabled: '#C7C7CC',
    background: '#FFFFFF',
    backgroundPressed: '#F2F2F7',
    checkmark: '#FFFFFF',
};

export type SizeType = 'small' | 'medium' | 'large';

export const getSizeConfig = (size: SizeType) => SIZES[size];
export const getColors = () => COLORS;

export const createStyles = (size: SizeType = 'medium', activeColor: string = COLORS.primary) => {
    const sizeConfig = SIZES[size];
    const colors = COLORS;

    return StyleSheet.create({
        // 容器
        container: {
            // 默认垂直排列
        },

        // 单个选项行
        itemContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            minHeight: sizeConfig.minHeight,
            paddingVertical: 12,
            paddingHorizontal: 16,
            backgroundColor: colors.background,
        },
        itemContainerPressed: {
            backgroundColor: colors.backgroundPressed,
        },
        itemContainerDisabled: {
            opacity: 0.6,
        },

        // 左布局：选择框在左
        itemContainerLeft: {
            flexDirection: 'row',
        },
        // 右布局：选择框在右
        itemContainerRight: {
            flexDirection: 'row-reverse',
        },

        // 文字容器
        textContainer: {
            flex: 1,
            justifyContent: 'center',
        },
        textContainerLeft: {
            marginLeft: 12,
        },
        textContainerRight: {
            marginRight: 12,
        },

        // 标签文字
        label: {
            fontSize: sizeConfig.fontSize,
            color: colors.text,
            fontWeight: '400',
        },
        labelDisabled: {
            color: colors.textDisabled,
        },

        // 描述文字
        description: {
            fontSize: sizeConfig.descriptionSize,
            color: colors.textSecondary,
            marginTop: 2,
        },
        descriptionDisabled: {
            color: colors.textDisabled,
        },

        // Checkbox 方框
        checkbox: {
            width: sizeConfig.boxSize,
            height: sizeConfig.boxSize,
            borderRadius: sizeConfig.borderRadius,
            borderWidth: 2,
            borderColor: colors.border,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colors.background,
        },
        checkboxChecked: {
            borderColor: activeColor,
            backgroundColor: activeColor,
        },
        checkboxIndeterminate: {
            borderColor: activeColor,
            backgroundColor: activeColor,
        },
        checkboxDisabled: {
            borderColor: colors.borderDisabled,
        },
        checkboxCheckedDisabled: {
            borderColor: colors.borderDisabled,
            backgroundColor: colors.borderDisabled,
        },

        // 勾选图标
        checkIcon: {
            // 由 DbIcon 渲染
        },

        // 不确定状态的横线
        indeterminateLine: {
            width: sizeConfig.iconSize,
            height: 2,
            backgroundColor: colors.checkmark,
            borderRadius: 1,
        },

        // 分隔线
        separator: {
            height: StyleSheet.hairlineWidth,
            backgroundColor: '#E5E5EA',
            marginLeft: 16,
        },
    });
};

export default createStyles;
